<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <h4 class="header-title mt-0 mb-1">{{$t('experience_level.form.information')}} </h4>
          <p class="sub-header"></p>

          <div class="row">

            <div class="col-12">
              <TextField 
                :placeholder="$t('experience_level.form.name.placeholder')"
                :label="$t('experience_level.form.name.label')"
                v-model="model.name"
                :error="$v.model.name.$error"
                :errorMessage="$v.model.name.errorMessage"
              />
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import  FormMixin from '@mixins/form'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    TextField: () => import('@components/form2/textfield')
  },
  mixins: [ FormMixin ],
  data(){
    return {
      model:{
        name: '',
      },
    }
  },
  validations: {
    model:{
      name: { required }
    }
  },
}
</script>